import { render, staticRenderFns } from "./iristarService.vue?vue&type=template&id=5214848b&scoped=true&"
import script from "./iristarService.vue?vue&type=script&lang=js&"
export * from "./iristarService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5214848b",
  null
  
)

export default component.exports